import { soFetch } from 'so-fetch';
import * as constants from './onboarding-constants';

export function submitOnboarding(onboardingInfo) {
  return soFetch('/proxy/onboarding', {
    method: 'post',
    body: onboardingInfo,
    actionType: constants.ONBOARDING_SUBMIT,
    responseBinding: 'payload',
  });
}

export function setOnboardingFields(fieldAndValue) {
  return {
    type: constants.SET_ONBOADING_FIELDS,
    payload: fieldAndValue,
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/onboarding/onboarding-actions.js